import React from "react";

const Footer = () => {
  return (
    <div className="w-100 bg-dark py-1 text-center">
      <p className="text-light">Copyright &copy; MERN Stack Food Delivery App</p>
    </div>
  );
};

export default Footer;
